export default "__VITE_ASSET__inv51SkO__"